import { render, staticRenderFns } from "./AdminElements.vue?vue&type=template&id=e3eb5d70"
import script from "./AdminElements.vue?vue&type=script&lang=js"
export * from "./AdminElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports